module.exports = __webpack_public_path__ + "static/pricing-eaf816a2c72ed71158850dcbafd3e1df.svg";